<template>
    <div class="d-flex gap-2 my-1 flex-wrap">
        <Badge
            v-for="category in shownCategories"
            :key="'event-category-' + category.id"
            tag="span"
            rounded
            class="selected-badge"
            :class="{'small-badge': smaller}">
            {{ category.Bezeichnung }}
        </Badge>
    </div>
</template>

<script>

export default {
    name: "EventCategories",
    props: {
        categories: {
            required: true,
            type: Array
        },
        smaller: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: null
        }
    },
    computed: {
        shownCategories() {
            if (this.max && this.categories?.length > this.max) {
                return this.categories.slice(0, this.max)
            }
            return this.categories
        }
    }
}
</script>

<style lang="scss" scoped>
.badge {
    text-transform: none;
    background-color: var(--category-background);
    color: var(--category-text);
    box-sizing: border-box;
    font-size: .8rem;
    font-weight: 500;
}

.selected-badge {
    background-color: var(--category-background);
    color: var(--category-text);
    border: 1px solid transparent;
    opacity: 0.65;

    &.small-badge {
        font-size: .625rem;
        padding: 0.25rem 0.275rem;
    }
}
</style>
